var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setErrorMessage } from '@popup/multichain/actions/message.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { loadActiveAccount } from '@popup/steem/actions/active-account.actions';
import { MultisigUtils } from '@popup/steem/utils/multisig.utils';
import SteemUtils from '@popup/steem/utils/steem.utils';
import { BackgroundCommand } from '@reference-data/background-message-key.enum';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CheckboxPanelComponent } from 'src/common-ui/checkbox/checkbox-panel/checkbox-panel.component';
import { SelectAccountSectionComponent } from 'src/common-ui/select-account-section/select-account-section.component';
const defaultConfig = {
    isEnabled: false,
    active: { isEnabled: false, publicKey: '', message: '' },
    posting: { isEnabled: false, publicKey: '', message: '' },
};
const Multisig = ({ activeAccount, accounts, setTitleContainerProperties, setErrorMessage, }) => {
    var _a, _b;
    const [multisigAccountConfig, setMultisigAccountConfig] = useState(defaultConfig);
    const [localAccount, setLocalAccount] = useState();
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_multisig',
            isBackButtonEnabled: true,
        });
    }, []);
    useEffect(() => {
        init();
    }, [activeAccount]);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        const multisigAccountConfig = yield MultisigUtils.getMultisigAccountConfig(activeAccount.name);
        setMultisigAccountConfig(multisigAccountConfig !== null && multisigAccountConfig !== void 0 ? multisigAccountConfig : defaultConfig);
        setLocalAccount(accounts.find((account) => account.name === activeAccount.name));
    });
    const saveMultisigEnabled = (isEnabled) => __awaiter(void 0, void 0, void 0, function* () {
        if (!MultisigUtils.isMultisigCompatible()) {
            setErrorMessage('min_chrome_version');
            return;
        }
        const newConfig = Object.assign(Object.assign({}, multisigAccountConfig), { isEnabled: isEnabled, active: Object.assign(Object.assign({}, multisigAccountConfig.active), { isEnabled: false }), posting: Object.assign(Object.assign({}, multisigAccountConfig.posting), { isEnabled: false }) });
        setMultisigAccountConfig(newConfig);
        yield MultisigUtils.saveMultisigConfig(activeAccount.name, newConfig);
        if (!isEnabled) {
            notifyBackground({
                account: activeAccount.name,
                connect: isEnabled,
            });
        }
    });
    const saveMultisigEnabledActive = (isEnabled) => __awaiter(void 0, void 0, void 0, function* () {
        let message = '';
        let publicKey = '';
        if (isEnabled) {
            message = SteemUtils.signMessage(activeAccount.name, localAccount === null || localAccount === void 0 ? void 0 : localAccount.keys.active);
            publicKey = localAccount === null || localAccount === void 0 ? void 0 : localAccount.keys.activePubkey;
        }
        const newConfig = Object.assign(Object.assign({}, multisigAccountConfig), { active: { isEnabled: isEnabled, message: message, publicKey: publicKey } });
        setMultisigAccountConfig(newConfig);
        yield MultisigUtils.saveMultisigConfig(activeAccount.name, newConfig);
        notifyBackground({
            account: activeAccount.name,
            connect: isEnabled,
            publicKey: multisigAccountConfig.active.publicKey,
            message: multisigAccountConfig.active.message,
        });
    });
    const saveMultisigEnabledPosting = (isEnabled) => __awaiter(void 0, void 0, void 0, function* () {
        let message = '';
        let publicKey = '';
        if (isEnabled) {
            message = SteemUtils.signMessage(activeAccount.name, localAccount === null || localAccount === void 0 ? void 0 : localAccount.keys.posting);
            publicKey = localAccount === null || localAccount === void 0 ? void 0 : localAccount.keys.postingPubkey;
        }
        const newConfig = Object.assign(Object.assign({}, multisigAccountConfig), { posting: { isEnabled: isEnabled, message: message, publicKey: publicKey } });
        setMultisigAccountConfig(newConfig);
        yield MultisigUtils.saveMultisigConfig(activeAccount.name, newConfig);
        notifyBackground({
            account: activeAccount.name,
            connect: isEnabled,
            publicKey: multisigAccountConfig.posting.publicKey,
            message: multisigAccountConfig.posting.message,
        });
    });
    const notifyBackground = (message) => {
        chrome.runtime.sendMessage({
            command: BackgroundCommand.MULTISIG_REFRESH_CONNECTIONS,
            value: message,
        });
    };
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_MULTISIG}-page`, className: "multisig-config-page" },
        React.createElement("div", { className: "intro", dangerouslySetInnerHTML: {
                __html: getMessage('popup_html_multisig_intro'),
            } }),
        React.createElement(SelectAccountSectionComponent, { fullSize: true, background: "white" }),
        multisigAccountConfig && (React.createElement(React.Fragment, null,
            React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-multisig-enabled", title: "popup_html_enable_multisig", checked: multisigAccountConfig === null || multisigAccountConfig === void 0 ? void 0 : multisigAccountConfig.isEnabled, onChange: (newValue) => saveMultisigEnabled(newValue), hint: "popup_html_enable_multisig" }),
            multisigAccountConfig.isEnabled && (React.createElement(React.Fragment, null,
                activeAccount.keys.active && (React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-multisig-active-key-enabled", title: "popup_html_enable_active_key_multisig", checked: ((_a = multisigAccountConfig === null || multisigAccountConfig === void 0 ? void 0 : multisigAccountConfig.active) === null || _a === void 0 ? void 0 : _a.isEnabled) || false, onChange: (newValue) => saveMultisigEnabledActive(newValue), disabled: false, hint: undefined })),
                activeAccount.keys.posting && (React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-multisig-public-key-enabled", title: "popup_html_enable_posting_key_multisig", checked: ((_b = multisigAccountConfig === null || multisigAccountConfig === void 0 ? void 0 : multisigAccountConfig.posting) === null || _b === void 0 ? void 0 : _b.isEnabled) || false, onChange: (newValue) => saveMultisigEnabledPosting(newValue), disabled: false, hint: undefined }))))))));
};
const mapStateToProps = (state) => {
    return {
        accounts: state.steem.accounts,
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    loadActiveAccount,
    setTitleContainerProperties,
    setErrorMessage,
});
export const MultisigComponent = connector(Multisig);
